import React, { useCallback, useEffect, useState } from 'react';
import {
  Form,
  FormGroup,
  Toggle,
  Button,
  Table,
  TableHead,
  TableHeader,
  TableBody,
  TableRow,
  TableCell,
  TextInput,
} from '@carbon/react';
//import { accordion_inner } from './SettingsPage.module.scss';

import { Add, Checkmark, Edit, EditOff, TrashCan } from '@carbon/react/icons';

import { v4 as uuidv4 } from 'uuid';

import '../_settings.scss';
import { useDispatch } from 'react-redux';
import { alertActions } from '../../../redux/actions';

export const RadioSettings = ({ item: propsItem, onSave = () => {} }) => {
  const dispatch = useDispatch();
  const [changed, setChanged] = useState(false);

  useEffect(() => {
    if (propsItem && propsItem.model && propsItem.settings) {
      console.info('Radio propsItem:', propsItem);
      setSettings({
        ...propsItem,
        streams: (
          (Array.isArray(propsItem.settings) ? propsItem.settings : []).find(
            (i) => i.id === 'art'
          ) || {
            options: [],
          }
        ).options,
        ID: propsItem.model.ID,
      });
    }
  }, [propsItem]);

  const [settings, setSettings] = useState({
    ID: 0,
    streams: [],
  });

  const changeHandle = useCallback(
    (item) => {
      let fa = { ...settings };
      if (item.isNew) {
        fa.streams = [...fa.streams, item];
      } else {
        let newStreams = settings.streams.map((i) =>
          i.uuid === item.uuid ? item : i
        );
        fa.streams = newStreams;
      }

      setSettings(fa);
      setChanged(true);
    },
    [settings]
  );

  const deleteHandle = useCallback(
    (item) => {
      let fa = { ...settings };
      fa.streams = fa.streams.filter((i) => i.uuid !== item.uuid);

      setSettings(fa);
      setChanged(true);
    },
    [settings]
  );

  const handleSave = useCallback(() => {
    // combine all settings to regular settings

    // Safety guard: never persist when the source settings could not be
    // decoded into the expected structure. Saving anyway would overwrite the
    // existing radio list (and thereby break every device's stream selection,
    // which references entries by their `value`) with an empty array.
    if (
      !Array.isArray(propsItem.settings) ||
      !propsItem.settings.some((i) => i.id === 'art')
    ) {
      dispatch(
        alertActions.error(
          'Radio-Einstellungen konnten nicht geladen werden — Speichern abgebrochen, um Datenverlust zu vermeiden.'
        )
      );
      return;
    }

    let preSaveSettings = { ...propsItem };

    preSaveSettings.ID = propsItem.model.ID;

    let newSettings = propsItem.settings.map((i) => {
      if (i.id === 'art') {
        return {
          ...i,
          options: settings.streams.map((stream) => {
            return {
              uuid: stream.uuid,
              name: stream.name,
              value: stream.value,
            };
          }),
        };
      } else {
        return i;
      }
    });

    // Keep settings as an array; the mutation layer (features.js) JSON-encodes
    // it exactly once. Stringifying here caused double-encoded rows in the DB.
    preSaveSettings.settings = newSettings;

    console.info('beofresavesettomgS:', propsItem);
    console.info(preSaveSettings);
    onSave(preSaveSettings);
  }, [onSave, settings, propsItem, dispatch]);

  return (
    <Form>
      <FormGroup legendText="Details">

        <Table size="sm">
          <TableHead>
            <TableRow>
              <TableHeader>Name</TableHeader>
              <TableHeader>Url</TableHeader>
              <TableHeader></TableHeader>
            </TableRow>
          </TableHead>
          <TableBody>
            {settings.streams.map((option) => (
              <RadioItem
                uuid={option.uuid}
                name={option.name}
                url={option.value}
                key={`radio_item_${option.uuid}`}
                onUpdate={changeHandle}
                onDelete={deleteHandle}
              />
            ))}

            <RadioItem key={`radio_item_new`} onUpdate={changeHandle} />
          </TableBody>
        </Table>
      </FormGroup>
      <br />
      <Button onClick={handleSave} disabled={!changed}>
        Speichern
      </Button>
    </Form>
  );
};

export const RadioItem = ({
  uuid: uuidProps,
  name: name_pre,
  url: url_pre,
  id,
  onUpdate = () => {},
  onDelete = () => {},
}) => {
  const dispatch = useDispatch();

  const [item, setItem] = useState({
    name: name_pre,
    value: url_pre,
    uuid: uuidProps,
  });

  const [editing, enableEditing] = useState(false);
  const [changed, setChanged] = useState(false);

  const resetInput = useCallback(() => {
    setItem({
      isNew: uuidProps === undefined || uuidProps === null,
      uuid: uuidProps || uuidv4(),
      name: name_pre,
      value: url_pre,
    });

    setChanged(false);
    enableEditing(uuidProps === undefined || uuidProps === null);
  }, [setItem, setChanged, enableEditing, uuidProps, name_pre, url_pre]);

  useEffect(() => {
    resetInput();
  }, [name_pre, url_pre, uuidProps, resetInput]);

  const editItem = useCallback(() => {
    enableEditing(true);
  }, [enableEditing]);

  const stopEditing = useCallback(() => {
    enableEditing(false);
    setItem({
      ...item,
      ...{
        name: name_pre,
        value: url_pre,
      },
    });
    setChanged(false);
  }, [enableEditing, setItem, name_pre, url_pre, setChanged, item]);

  const handleChangeField = useCallback(
    (field, value) => {
      let newItem = {};
      newItem[field] = value;

      setItem({ ...item, ...newItem });
      setChanged(true);
    },
    [setItem, item, setChanged]
  );

  const handleUpdate = useCallback(() => {
    if (
      item.name !== null &&
      item.name !== undefined &&
      item.name !== '' &&
      item.value !== null &&
      item.value !== undefined &&
      item.value !== '' &&
      item.uuid !== null &&
      item.uuid !== undefined &&
      item.uuid !== ''
    ) {
      onUpdate(item);
      if (item.isNew === true) {
        resetInput();
      }
    } else {
      //dispatch(dispatch(alertActions.success(success_message || data));)

      dispatch(alertActions.error('Name und URL müssen Daten beinhalten!'));
    }
  }, [onUpdate, item, dispatch, resetInput]);

  return (
    <TableRow dataid={id}>
      <TableCell>
        {editing === true ? (
          <TextInput
            labelText=""
            value={item.name || ''}
            id={`row_${id}_name_field`}
            onChange={(e) => handleChangeField('name', e.target.value)}
          />
        ) : (
          item.name
        )}
      </TableCell>
      <TableCell>
        {editing === true ? (
          <TextInput
            labelText=""
            value={item.value || ''}
            id={`row_${id}_value_field`}
            onChange={(e) => handleChangeField('value', e.target.value)}
            spellCheck={false}
          />
        ) : (
          item.value
        )}
      </TableCell>
      {item.isNew ? (
        <TableCell>
          <Button
            renderIcon={(props) => <Add size={20} {...props}/>}
            iconDescription="Stream hinzufügen"
            hasIconOnly
            size="sm"
            kind="primary"
            onClick={handleUpdate}
          />
        </TableCell>
      ) : (
        <TableCell>
          {editing === false ? (
            <Button
              renderIcon={(props) => <Edit size={20} {...props}/>}
              iconDescription="bearbeiten"
              hasIconOnly
              size="sm"
              kind="primary"
              onClick={editItem}
              className="row_editing_button"
            />
          ) : (
            <>
              <Button
                renderIcon={(props) => <EditOff size={20} {...props}/>}
                iconDescription="bearbeiten abbrechen"
                hasIconOnly
                size="sm"
                kind="primary"
                onClick={stopEditing}
                className="row_editing_button"
              />
              {changed && (
                <Button
                  renderIcon={(props) => <Checkmark size={20} {...props}/>}
                  iconDescription="updaten"
                  hasIconOnly
                  size="sm"
                  kind="primary"
                  onClick={handleUpdate}
                  className="row_editing_button"
                />
              )}
              <Button
                renderIcon={(props) => <TrashCan size={20} {...props}/>}
                iconDescription="entfernen"
                hasIconOnly
                size="sm"
                kind="danger"
                onClick={() => onDelete(item)}
                className="row_editing_button"
              />
            </>
          )}
        </TableCell>
      )}
    </TableRow>
  );
};
